import {defineStore} from 'pinia'
import {API_ENDPOINTS, ROUTES} from '@/config'
import {http} from '@/extensions/http'
import {session} from '@/extensions/session'
import router from '@/router'
import {useAlertStore} from '@/store/alert.js'
import {useUserStore} from '@/store/user.js'

export const useAuthStore = defineStore('auth', {
    state: () => {
        return {
            logged_in: false,
            ready: false,
            user: null
        }
    },
    actions: {
        async confirm(payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.AUTH.CONFIRM, payload)

                if (data) await this.setUser(data)

                return null
            } catch (exception) {
                return exception?.response?.data?.message
            }
        },
        async init() {
            try {
                if (!session.isExpired()) {
                    await http.get(API_ENDPOINTS.AUTH.SANCTUM_CSRF)
                    const {data} = await http.get(API_ENDPOINTS.ME)

                    if (data) {
                        await this.setUser(data)
                    }
                }
            } catch { /**/ }

            this.ready = true
        },
        async login(payload) {
            try {
                await http.get(API_ENDPOINTS.AUTH.SANCTUM_CSRF)
                await http.post(API_ENDPOINTS.AUTH.LOGIN, payload)

                return true
            } catch (exception) {
                return false
            }
        },
        async logout() {
            try {
                this.ready = false
                await http.post(API_ENDPOINTS.AUTH.LOGOUT)

                this.logged_in = false
                session.deleteExpiration()
                await router.push({name: ROUTES.AUTH.LOGIN})

                window.location.reload()
            } catch { /**/ }
            this.ready = true
        },
        async setUser(data) {
            this.user = data
            this.logged_in = true
            session.saveExpiration()

            await useAlertStore().init()
            await useUserStore().init()
        }
    }
})